import { CENTRA_LANGUAGE_CODE, type CentraLanguageCode } from "@/data/supported-languages"
import { SHIPPING_COUNTRIES, type ShippingCountry } from "@/data/shipping-countries"

export type CountryToDefaultLanguageMap = Map<ShippingCountry, CentraLanguageCode>

const countryToDefaultLanguageMap: CountryToDefaultLanguageMap = new Map<
    ShippingCountry,
    CentraLanguageCode
>([
    [SHIPPING_COUNTRIES.Austria, CENTRA_LANGUAGE_CODE.De],
    [SHIPPING_COUNTRIES.Belgium, CENTRA_LANGUAGE_CODE.Fr],
    [SHIPPING_COUNTRIES.Bulgaria, CENTRA_LANGUAGE_CODE.En],
    [SHIPPING_COUNTRIES.Croatia, CENTRA_LANGUAGE_CODE.En],
    [SHIPPING_COUNTRIES.Cyprus, CENTRA_LANGUAGE_CODE.En],
    [SHIPPING_COUNTRIES.CzechRepublic, CENTRA_LANGUAGE_CODE.En],
    [SHIPPING_COUNTRIES.Denmark, CENTRA_LANGUAGE_CODE.En],
    [SHIPPING_COUNTRIES.Estonia, CENTRA_LANGUAGE_CODE.En],
    [SHIPPING_COUNTRIES.Finland, CENTRA_LANGUAGE_CODE.En],
    [SHIPPING_COUNTRIES.France, CENTRA_LANGUAGE_CODE.Fr],
    [SHIPPING_COUNTRIES.Germany, CENTRA_LANGUAGE_CODE.De],
    [SHIPPING_COUNTRIES.Greece, CENTRA_LANGUAGE_CODE.En],
    [SHIPPING_COUNTRIES.Hungary, CENTRA_LANGUAGE_CODE.En],
    [SHIPPING_COUNTRIES.Ireland, CENTRA_LANGUAGE_CODE.En],
    [SHIPPING_COUNTRIES.Italy, CENTRA_LANGUAGE_CODE.En],
    [SHIPPING_COUNTRIES.Latvia, CENTRA_LANGUAGE_CODE.En],
    [SHIPPING_COUNTRIES.Lithuania, CENTRA_LANGUAGE_CODE.En],
    [SHIPPING_COUNTRIES.Luxembourg, CENTRA_LANGUAGE_CODE.En],
    [SHIPPING_COUNTRIES.Malta, CENTRA_LANGUAGE_CODE.En],
    [SHIPPING_COUNTRIES.Netherlands, CENTRA_LANGUAGE_CODE.En],
    [SHIPPING_COUNTRIES.NewZealand, CENTRA_LANGUAGE_CODE.En],
    [SHIPPING_COUNTRIES.Norway, CENTRA_LANGUAGE_CODE.En],
    [SHIPPING_COUNTRIES.Poland, CENTRA_LANGUAGE_CODE.En],
    [SHIPPING_COUNTRIES.Portugal, CENTRA_LANGUAGE_CODE.En],
    [SHIPPING_COUNTRIES.Romania, CENTRA_LANGUAGE_CODE.En],
    [SHIPPING_COUNTRIES.Slovakia, CENTRA_LANGUAGE_CODE.En],
    [SHIPPING_COUNTRIES.Slovenia, CENTRA_LANGUAGE_CODE.En],
    [SHIPPING_COUNTRIES.Spain, CENTRA_LANGUAGE_CODE.En],
    [SHIPPING_COUNTRIES.Sweden, CENTRA_LANGUAGE_CODE.En],
    [SHIPPING_COUNTRIES.Switzerland, CENTRA_LANGUAGE_CODE.De],
    [SHIPPING_COUNTRIES.UnitedKingdom, CENTRA_LANGUAGE_CODE.En],
    [SHIPPING_COUNTRIES.Canada, CENTRA_LANGUAGE_CODE.En],
    [SHIPPING_COUNTRIES.USA, CENTRA_LANGUAGE_CODE.En],
    [SHIPPING_COUNTRIES.Australia, CENTRA_LANGUAGE_CODE.En],
    [SHIPPING_COUNTRIES.Japan, CENTRA_LANGUAGE_CODE.Ja]
])

export default countryToDefaultLanguageMap

export const getDefaultLanguageFromCountry = (
    country: ShippingCountry
): CentraLanguageCode => countryToDefaultLanguageMap.get(country) || "en"

export function getCountryNameByCode(countryCode: string): string | undefined {
    const foundEntry = [...countryToDefaultLanguageMap].find(
        ([_, code]) => code === countryCode
    )
    return foundEntry ? foundEntry[0] : undefined
}

export function getCountryNameByLanguageCode(
    languageCode: CentraLanguageCode
): ShippingCountry | undefined {
    for (const [country, code] of countryToDefaultLanguageMap) {
        if (code === languageCode) {
            return country
        }
    }
    return undefined
}
